import { createTheme } from '@mui/material/styles';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: '#22D3EE',        // Cyan (Aurora)
      light: '#67E8F9',
      dark: '#0891B2',
      contrastText: '#000000',
    },
    secondary: {
      main: '#6366F1',        // Indigo
      light: '#818CF8',
      dark: '#4F46E5',
      contrastText: '#FFFFFF',
    },
    background: {
      default: mode === 'dark' ? '#050505' : '#F9FAFB', // Neutral Black base
      paper: mode === 'dark' ? '#0F0F0F' : '#FFFFFF',   // Secondary neutral dark
      elevated: mode === 'dark' ? '#141414' : '#F3F4F6',
    },
    text: {
      primary: mode === 'dark' ? '#F9FAFB' : '#111827',
      secondary: mode === 'dark' ? '#9CA3AF' : '#4B5563',
      disabled: mode === 'dark' ? '#4B5563' : '#9CA3AF',
    },
    divider: mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',
    notification: {
      panelBg: mode === 'dark' ? 'rgba(15, 15, 15, 0.95)' : 'rgba(255, 255, 255, 0.95)',
      panelBorder: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      '"Outfit"',
      'sans-serif',
    ].join(','),
    fontSize: 14,
    h1: { fontFamily: 'Outfit', fontWeight: 800, letterSpacing: '-0.03em' },
    h2: { fontFamily: 'Outfit', fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontFamily: 'Outfit', fontWeight: 700, letterSpacing: '-0.02em' },
    h4: { fontFamily: 'Outfit', fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontFamily: 'Outfit', fontWeight: 600, letterSpacing: '-0.01em' },
    h6: { fontFamily: 'Outfit', fontWeight: 600 },
    body1: { fontSize: '1rem', lineHeight: 1.5, fontWeight: 500 },
    body2: { fontSize: '0.875rem', lineHeight: 1.5 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '8px 20px',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(34, 211, 238, 0.2)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
          color: '#fff',
          '&:hover': {
            background: 'linear-gradient(135deg, #06B6D4 0%, #4F46E5 100%)',
            boxShadow: '0 8px 20px rgba(34, 211, 238, 0.3)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: 16,
          border: mode === 'dark' ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          background: mode === 'dark' ? 'rgba(15, 15, 15, 0.7)' : '#fff',
          backdropFilter: 'blur(20px)',
          border: mode === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          '&:hover': {
            borderColor: 'rgba(34, 211, 238, 0.4)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
          },
        },
      },
    },
  },
});

export const theme = (mode) => createTheme(getDesignTokens(mode));
